import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const OurFleet = () => {
//   const fleet = [
//     {
//       title: "Swift Dzire",
//       seats: "Seats: 4+1 Seater",
//         image: "/images/ourfleets/1.jpg",
//       link: "/booking",
//       color: "#ff6600",
//     },
//     {
//       title: "Aura",
//       seats: "Seats: 4+1 Seater",
//       image: "/images/ourfleets/2.jpg",
//       link: "/booking",
//       color: "#d8a300",
//     },
//     {
//       title: "Toyota Rumion",
//       seats: "Seats: 6+1 Seater",
//        image: "/images/ourfleets/3.jpg",
//       link: "/booking",
//       color: "#ff6600",
//     },
//     {
//       title: "Innova Crysta",
//       seats: "Seats: 6+1 Seater",
//       image: "/images/ourfleets/4.jpg",
//       link: "/booking",
//       color: "#d8a300",
//     },
//     {
//       title: "Ertiga",
//       seats: "Seats: 6+1 Seater",
//   image: "/images/ourfleets/5.jpg",
//       link: "/booking",
//       color: "#ff6600",
//     },
//     {
//       title: "Kia Carens",
//       seats: "Seats: 6+1 Seater",
//    image: "/images/ourfleets/6.jpg",
//       link: "/booking",
//       color: "#d8a300",
//     },
//     {
//   title: "Innova",
//   seats: "Seats: 6+1 Seater",
//    image: "/images/ourfleets/7.jpg",
//   link: "/booking",
//   color: "#ff6600",
// },
// {
//   title: "Fortuner",
//   seats: "Seats: 6+1 Seater",
//  image: "/images/ourfleets/8.avif",
//   link: "/booking",
//   color: "#d8a300",
// },
// {
//   title: "Tempo Traveller",
//   seats: "Seats: 9, 12, 13, 17, 20 Seater",
//    image: "/images/ourfleets/9.jpg",
//   link: "/booking",
//   color: "#ff6600",
// },
// {
//   title: "Urbania",
//   seats: "Seats: 13, 17, 20 Seater",
//   image: "/images/ourfleets/10.jpg",
//   link: "/booking",
//   color: "#d8a300",
// },
// {
//   title: "Mini Bus",
//   seats: "Seats: 21–27 Seater",
//   image: "/images/ourfleets/11.webp",
//   link: "/booking",
//   color: "#ff6600",
// },
// {
//   title: "Luxury Bus",
//   seats: "Seats: 35–45 Seater",
//   image: "/images/ourfleets/12.jpg",
//   link: "/booking",
//   color: "#d8a300",
// },

//   ];



const fleet = [
  {
    title: "Maruti Swift Dzire",
    seats: "5 Seater",
    image: "/images/fleets/1.jpg",
    link: "/booking",
    color: "#ff6600",
  },
  {
    title: "Toyota Etios",
    seats: "5 Seater",
    image: "/images/fleets/6.jpg",
    link: "/booking",
    color: "#d8a300",
  },
  {
    title: "Honda Amaze",
    seats: "5 Seater",
    image: "/images/fleets/7.jpg",
    link: "/booking",
    color: "#ff6600",
  },
  {
    title: "Toyota Corolla Altis",
    seats: "5 Seater",
    image: "/images/fleets/8.jpg",
    link: "/booking",
    color: "#d8a300",
  },
  {
    title: "Maruti Ertiga",
    seats: "7 Seater",
    image: "/images/fleets/2.jpg",
    link: "/booking",
    color: "#ff6600",
  },
  {
    title: "Tavera",
    seats: "7 Seater",
    image: "/images/fleets/5.jpg",
    link: "/booking",
    color: "#d8a300",
  },
  {
    title: "Toyota Innova",
    seats: "7-8 Seater",
    image: "/images/fleets/9.jpg",
    link: "/booking",
    color: "#ff6600",
  },
  {
    title: "Innova Crysta",
    seats: "7-8 Seater",
    image: "/images/fleets/10.jpg",
    link: "/booking",
    color: "#d8a300",
  },
  {
    title: "Scorpio",
    seats: "7-9 Seater",
    image: "/images/fleets/3.jpg",
    link: "/booking",
    color: "#ff6600",
  },
  {
    title: "Mini Bus Traveller",
    seats: "25-30 Seater",
    image: "/images/fleets/12.jpg",
    link: "/booking",
    color: "#d8a300",
  },
];


  return (
<>
 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title">Our Fleet</h2>
        </div>
      </div>
    </section>





    <section className="our-fleet-section py-5">
      <div className="container">
        {/* <h2 className="fleet-title text-center mb-5">Our Fleet</h2> */}
        <div className="row">
          {fleet.map((car, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="fleet-card h-100">
                <img src={car.image} alt={car.title} className="fleet-img" />
                <div className="fleet-body p-3">
                  <h4 className="fleet-name">{car.title}</h4>
                  <p className="fleet-seats">{car.seats}</p>
                  {/* <p className="fleet-desc">{car.description}</p> */}
                  <a
                    href={car.link}
                    className="fleet-btn"
                    style={{ backgroundColor: car.color }}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
</>
  );
};

export default OurFleet;
